<template>
  <div class="user-type-tabs">
    <ul>
      <li
        v-for="(val, index) in values"
        class="user-type-tab"
        :key="index"
        :class="{ 'is-active': activeTab === val }"
      >
        <a @click="activateTab(val)" class="tab-link">
          {{ labels[val] }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'UserTypeTabs',
  props: {
    values: {
      type: Array,
    },
    labels: {
      type: Object,
    },
    activateTab: {
      type: Function,
    },
    activeTab: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';
.user-type-tabs {
  font-family: $family-primary;
  background-color: $white-bis;
  ul {
    li {
      width: 50%;
      display: inline-block;
      text-align: center;
      background-color: rgba(234, 79, 93, 0.1);

      .tab-link {
        display: block;
        padding: 1rem 1.75rem;
        color: $primary-button;
        font-weight: 500;
        text-transform: uppercase;
        font-size: 1rem;
        opacity: 0.6;
      }

      &.is-active {
        background-color: $white;
        border-top-left-radius: 0.375rem;
        border-top-right-radius: 0.375rem;

        .tab-link {
          font-weight: 600;
          opacity: 1;
        }
      }
    }
  }
}
</style>
